import cn from '../utils/cn';
import KoobAvatar from './KoobAvatar';

const SIZES = { sm: 8, md: 10, lg: 12 } as const;

/**
 * The user's round KoobAvatar for the navbar and menus. While
 * `impersonating`, a red dot on its corner reminds the admin whose
 * account they are in.
 */
export default function KoobNavbarAvatar({
  name,
  imageUrl,
  impersonating = false,
  size = 'md',
  className,
}: {
  name?: string;
  imageUrl?: string;
  impersonating?: boolean;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span className={cn('relative inline-flex shrink-0', className)}>
      <KoobAvatar
        src={imageUrl}
        name={name}
        alt={name}
        icon={<i className="far fa-user fa-fw" />}
        size={SIZES[size]}
        rounded="full"
      />

      {impersonating && (
        <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white" />
      )}
    </span>
  );
}
